import React, { createContext, useContext, useState } from 'react';

import { queryClient } from 'react-query';

export const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider(props) {
    const [auth, setAuth] = useState(() => {
        const stored = JSON.parse(localStorage.getItem(process.env.REACT_APP_JWT_KEY));

        // Legacy session without refresh token. Force re-login
        if (stored && !stored.refreshToken) {
            localStorage.removeItem(process.env.REACT_APP_JWT_KEY);
            return null;
        }

        return stored;
    });

    // Set authentication token in localStorage and authToken context
    const login = (token) => {
        localStorage.setItem(process.env.REACT_APP_JWT_KEY, JSON.stringify(token));
        setAuth(token);
    };

    const logout = async () => {
        // Revoke refresh token on the server
        try {
            const stored = JSON.parse(localStorage.getItem(process.env.REACT_APP_JWT_KEY));
            if (stored?.refreshToken) {
                await fetch(process.env.REACT_APP_API_URL + '/apiv2/auth/logout', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ refreshToken: stored.refreshToken }),
                });
            }
        } catch {
            // Best-effort — still clear local state even if API call fails
        }

        localStorage.removeItem(process.env.REACT_APP_JWT_KEY);

        // Drop cached server data (and cancel in-flight queries) before the re-render
        // unmounts the private routes, so nothing leaks into the next login.
        queryClient.clear();

        setAuth();
    };

    const setHost = (id, name) => {
        // Read from localStorage to avoid overwriting tokens that were refreshed in the background
        const stored = JSON.parse(localStorage.getItem(process.env.REACT_APP_JWT_KEY));
        const updated = { ...stored, hostId: id, hostName: name };
        localStorage.setItem(process.env.REACT_APP_JWT_KEY, JSON.stringify(updated));
        setAuth(updated);
    };

    return (
        <AuthContext.Provider value={{ auth, login, logout, setHost }}>
            {props.children}
        </AuthContext.Provider>
    );
}
